import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Eye, EyeOff, LogIn, AlertCircle } from 'lucide-react';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.username, form.password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Username atau password salah');
      setTimeout(() => {
        document.getElementById('login-password')?.focus();
        document.getElementById('login-password')?.select();
      }, 50);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field) => (e) => {
    setForm(f => ({ ...f, [field]: e.target.value }));
    if (error) setError('');
  };

  return (
    <div className="login-page">
      <div style={{ width: '100%', maxWidth: 420 }}>
        {/* Header - Logo Jaya Raya */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ margin: '0 auto 16px', display: 'flex', justifyContent: 'center' }}>
            <div style={{ padding: 8, }}>
              <img
                src="/images/jayaraya.png"
                alt="Logo Jaya Raya"
                style={{
                  width: 90,
                  height: 90,
                  objectFit: 'contain'
                }}
              />
            </div>
          </div>
          <h1 style={{ color: 'white', fontSize: 28, fontWeight: 800, letterSpacing: '-0.5px', marginBottom: 4 }}>
            Penjadwalan Acara Pimpinan
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13 }}>Sekretariat DPRD Provinsi DKI Jakarta</p>
        </div>

        {/* Form card */}
        <div style={{ background: 'white', borderRadius: 20, padding: 32, boxShadow: '0 25px 50px rgba(0,0,0,0.3)' }}>
          {/* Judul form = LOGIN (sesuai review kotak kuning) */}
          <h2 style={{ fontSize: 22, fontWeight: 800, color: 'var(--gray-900)', marginBottom: 24, textAlign: 'center', letterSpacing: 1 }}>
            LOGIN
          </h2>

          {/* Alert error */}
          {error && (
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '12px 14px', marginBottom: 20, background: 'var(--red-bg)', border: '1px solid #FCA5A5', borderRadius: 10, animation: 'fadeInDown 0.2s ease' }}>
              <AlertCircle size={18} color="var(--red)" style={{ flexShrink: 0, marginTop: 1 }} />
              <div>
                <div style={{ fontSize: 14, fontWeight: 600, color: '#B91C1C' }}>Login Gagal</div>
                <div style={{ fontSize: 13, color: '#B91C1C', marginTop: 2 }}>{error}</div>
              </div>
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div className="form-group">
              <label className="form-label" htmlFor="login-username">Username</label>
              <input id="login-username" className={`form-input ${error ? 'input-error' : ''}`}
                type="text" placeholder="Masukkan username"
                value={form.username} onChange={handleChange('username')}
                autoComplete="username" autoFocus disabled={loading} />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="login-password">Password</label>
              <div style={{ position: 'relative' }}>
                <input id="login-password" className={`form-input ${error ? 'input-error' : ''}`}
                  type={showPass ? 'text' : 'password'} placeholder="Masukkan password"
                  value={form.password} onChange={handleChange('password')}
                  autoComplete="current-password" disabled={loading}
                  style={{ paddingRight: 44, width: '100%' }} />
                <button type="button" onClick={() => setShowPass(!showPass)} tabIndex={-1}
                  style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray-400)', display: 'flex', alignItems: 'center', padding: 0 }}>
                  {showPass ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <button type="submit" className="btn btn-primary btn-lg btn-full"
              disabled={loading || !form.username || !form.password} style={{ marginTop: 8 }}>
              {loading ? <><span className="loader" /> Memproses...</> : <><LogIn size={18} /> Masuk</>}
            </button>
          </form>
        </div>
      </div>
      <style>{`@keyframes fadeInDown { from{opacity:0;transform:translateY(-8px)} to{opacity:1;transform:translateY(0)} }`}</style>
    </div>
  );
}
